import { ExternalLink } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import IgMobileDialog from "@intelligems/ig-theme/mobile/IgMobileDialog";
import {
  themeAcknowledgementLabel,
  themeWarningDescription,
  themeWarningTitle,
} from "@src/components/themeExperienceWarning";
import { endingThemeTest } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

interface MobileThemeAcknowledgementModalProps {
  open: boolean;
  onClose: () => void;
  onAcknowledge: () => void;
  action: "pause" | "end";
  loading?: boolean;
  /** Resolved via `useThemeExperienceThemeNames`; `[]` falls back to generic copy. */
  themeNames: string[];
}

export const MobileThemeAcknowledgementModal = ({
  open,
  onClose,
  onAcknowledge,
  action,
  loading = false,
  themeNames,
}: MobileThemeAcknowledgementModalProps) => (
  <IgMobileDialog
    open={open}
    onClose={onClose}
    title={themeWarningTitle(action, "experiment", themeNames)}
    yesButtonText="I Acknowledge"
    noButtonText={null}
    handleYesClick={onAcknowledge}
    loading={loading}
  >
    <IgTypography variant="body2">
      {themeWarningDescription(action, "experiment")}
    </IgTypography>

    <IgTypography variant="body2" sx={{ mt: 2 }}>
      {themeAcknowledgementLabel(action, "experiment", themeNames)}
    </IgTypography>

    {/* Help Link */}
    <IgTypography
      variant="body2"
      sx={{
        color: "primary.main",
        cursor: "pointer",
        mt: 2,
        textDecoration: "underline",
      }}
      onClick={() => openNewTab(endingThemeTest)}
    >
      How to End a Theme Test{" "}
      <ExternalLink
        size={12}
        style={{ display: "inline", verticalAlign: "middle" }}
      />
    </IgTypography>
  </IgMobileDialog>
);
